export const DomainEventNames = {
  Payment: 'PAYMENT',
  SelectConsultType: 'SELECT_CONSULT_TYPE',
  ConditionsWeTreat: 'CONDITIONS_WE_TREAT',
  SelectPathologyType: 'SELECT_PATHOLOGY_TYPE',
  SelectCareCardType: 'SELECT_CARE_CARD_TYPE',
  ApplyCareCard: 'APPLY_CARE_CARD',
};

export const DomainEventParameters = {
  ChargeCode: 'charge_code',
  PaymentType: 'payment_type',
  PaymentAmount: 'payment_amount',
  MemberId: 'member_id',
  EventDatetime: 'event_datetime',
  ServiceType: 'serviceType',
  MembershipType: 'membershipType',
};

export const MembershipType = {
  MainMember: 'MAIN_MEMBER',
  Dependent: 'DEPENDENT',
};

export const PaymentType = {
  Eft: 'EFT',
  Card: 'card',
  OneVoucher: '1 Voucher',
};
